import * as React from 'react';
import {Link} from 'react-router-dom';

import {Bubble} from '@deviceinsight/ng-ui-basic-components';
import {Asset, Gateway} from '@deviceinsight/ng-ui-api-client';

import {Trans} from '@deviceinsight/ng-ui-scale-lib/api';
import assetIcon from '../../assets/icon_asset.svg';
import gatewayIcon from '../../assets/icon_gateway.svg';

type Props = {
	asset: Asset;
	gateway: Gateway | null | undefined;
};
export const AssetLabel = ({asset}: {asset: Asset}) => (
	<span>
		<img
			src={assetIcon}
			alt="asset"
			style={{
				marginRight: 8,
				opacity: 0.6,
				width: 16,
				height: 16
			}}
		/>
		<Trans context={asset} i18nKey="asset.moduleName">
			Asset
		</Trans>
	</span>
);
export const GatewayLabel = ({gateway}: {gateway: Gateway | Asset}) => (
	<span>
		<img
			src={gatewayIcon}
			alt="gateway"
			style={{
				marginRight: 8,
				opacity: 0.6,
				width: 16,
				height: 16
			}}
		/>
		<Trans context={gateway} i18nKey="asset.gateway">
			Gateway
		</Trans>
	</span>
);
export default class AssetTypeWithGatewayBubble extends React.Component<Props> {
	render() {
		const {asset, gateway} = this.props;

		if (asset.isGateway) {
			return <GatewayLabel gateway={gateway || asset} />;
		} else {
			if (gateway) {
				const popoverContent = (
					<span>
						<img
							src={gatewayIcon}
							alt="gateway"
							style={{
								marginRight: 8,
								filter: 'invert(1)',
								width: 16,
								height: 16
							}}
						/>
						<Link to={`/assets/${gateway.id}`}>{gateway.name}</Link>
					</span>
				);
				return (
					<Bubble content={popoverContent} inverted>
						<AssetLabel asset={asset} />
					</Bubble>
				);
			} else {
				return <AssetLabel asset={asset} />;
			}
		}
	}
}
